import { useQuery } from "@tanstack/react-query";

/**
 * Custom hook to fetch public meal plan data from API
 * @param {string} organizationId - Organization ID
 * @param {string} mealPlanId - Meal plan ID
 */
export const usePublicMealPlan = (organizationId, mealPlanId) => {
  return useQuery({
    queryKey: ["publicMealPlan", organizationId, mealPlanId],
    queryFn: async () => {
      if (!organizationId || !mealPlanId) {
        throw new Error("Organization ID and Meal Plan ID are required");
      }

      const cloudFunctionUrl = "https://app.mighty45.com";

      const response = await fetch(
        `${cloudFunctionUrl}/api/v1/public/meal-plan/${organizationId}/${mealPlanId}`,
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`,
        );
      }

      return response.json();
    },
    enabled: !!organizationId && !!mealPlanId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: (failureCount, error) => {
      // Don't retry on 403/404 errors
      if (error.message.includes("403") || error.message.includes("404")) {
        return false;
      }
      return failureCount < 3;
    },
  });
};

export default usePublicMealPlan;
